// removed by extract-text-webpack-plugin
module.exports = {"fixed":"src-local_modules-sticky-scroll-__sticky-scroll-box-module___fixed"};


//////////////////
// WEBPACK FOOTER
// ./src/local_modules/sticky-scroll/sticky-scroll-box.module.css
// module id = 41
// module chunks = 0